var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thumbnail",style:({
    width: (_vm.dimension + "px"),
    height: (_vm.dimension + "px"),
    'background-image': ("url(" + _vm.url + ")"),
    'background-size': '100%',
    'background-position': 'center',
    'border-radius': (_vm.borderRadius + "px")
  })},[_c('div',{staticClass:"shade",style:({ 'border-radius': (_vm.borderRadius + "px") })})])}
var staticRenderFns = []

export { render, staticRenderFns }